import { react2angular } from 'react2angular';
import { AlarmRuleList } from './AlarmRuleList';

angular
  .module('webtip.module')
  .component('alarmRuleList', react2angular(AlarmRuleList, [
    'isActive',
    'onView',
    'onEdit',
    'onRunReport',
  ], ['alarmRuleService', 'alarmNotificationService', 'userService']));